import { queryOptions } from '@tanstack/react-query';

import { cleanParams } from '@/utils/cleanParams';

import { apiAddressBookBffFetch } from '..';
import type {
  ContactListViewRes,
  ContactView,
  EligibleIntroducerContactsRes,
  GetContactsViewParams,
  GetEligibleIntroducersParams,
  WalletRecipientListRes,
} from './types';

export const ADDRESS_BOOK_BFF_QUERY_KEYS = {
  eligibleIntroducers: 'address-book-eligible-introducers',
  contacts: 'address-book-contacts',
  walletRecipients: 'address-book-wallet-recipients',
  contactHistory: 'address-book-contact-history',
} as const;

export const _getEligibleIntroducers = (params?: GetEligibleIntroducersParams) =>
  queryOptions({
    queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.eligibleIntroducers, ...Object.values(params ?? {})],
    queryFn: () =>
      apiAddressBookBffFetch<EligibleIntroducerContactsRes>('/contacts/eligible-introducers', {
        params: cleanParams({ ...params }),
      }),
    staleTime: 5 * 60 * 1000,
  });

export const _getBffContacts = (params?: GetContactsViewParams) =>
  queryOptions({
    queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.contacts, params],
    queryFn: () =>
      apiAddressBookBffFetch<ContactListViewRes>('/contacts', {
        params: cleanParams({ ...params }),
      }),
    refetchOnMount: true,
    retry: 1,
  });

export const _getWalletRecipients = (search: string) => {
  const normalizedSearch = search.trim();

  return queryOptions({
    queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.walletRecipients, normalizedSearch],
    queryFn: ({ signal }) =>
      apiAddressBookBffFetch<WalletRecipientListRes>('/wallet-recipients', {
        params: {
          search: normalizedSearch,
          limit: 10,
        },
        signal,
      }),
    retry: false,
  });
};

export const _getBffContactById = (id?: string) =>
  queryOptions({
    enabled: !!id,
    queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.contacts, id],
    queryFn: () => apiAddressBookBffFetch<ContactView>(`/contacts/${id}`),
    refetchOnMount: true,
    retry: 1,
  });
